// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tPje","label":"styles_label__2YZ24"};